import {
  GET_SUPPORT_SUCCESS,
  GET_SUPPORT_FAIL,
  GET_SUPPORT_DETAILS_SUCCESS,
  GET_SUPPORT_DETAILS_FAIL,
  ADD_SUPPORT_SUCCESS,
  ADD_SUPPORT_FAIL,
  UPDATE_SUPPORT_SUCCESS,
  UPDATE_SUPPORT_FAIL,
  DELETE_SUPPORT_SUCCESS,
  DELETE_SUPPORT_FAIL,
  RESET_SUPPORT_STATE,
  EXPORT_SUPPORT_SUCCESS,
  EXPORT_SUPPORT_FAIL,
  RESET_SUPPORT_ATTACHMENT_STATE
} from "./actionTypes"

const INIT_STATE = {
  support: [],
  supportDetails: [],
  addSupport: [],
  editSupport: [],
  delSupport: [],
  exportSupport: [],
}

const Support = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SUPPORT_SUCCESS:
      return {
        ...state,
        support: action.payload,
      }

    case GET_SUPPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_SUPPORT_DETAILS_SUCCESS:
      return {
        ...state,
        supportDetails: action.payload,
      }

    case GET_SUPPORT_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_SUPPORT_SUCCESS:
      return {
        ...state,
        addSupport: action.payload,
        supportDetails: action.payload.data,
      }

    case ADD_SUPPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_SUPPORT_SUCCESS:
      return {
        ...state,
        supportDetails: action.payload.data,
        editSupport: action.payload,
      }

    case UPDATE_SUPPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      
    case DELETE_SUPPORT_SUCCESS:
      return {
        ...state,
        supportDetails: action.payload,
        delSupport: action.payload,
      }

    case DELETE_SUPPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case EXPORT_SUPPORT_SUCCESS:
        return {
          ...state,
          exportSupport: action.payload,
        }

      case EXPORT_SUPPORT_FAIL:
        return {
          ...state,
          error: action.payload,
        }
    case RESET_SUPPORT_STATE:
      return {
        ...state,
        addSupport: [],
        supportDetails: [],
        editSupport: [],
        delSupport: [],
        exportSupport: [],
      }
    case RESET_SUPPORT_ATTACHMENT_STATE:
      return {
        ...state,
        exportSupport: [],
      }
    default:
      return state
  }
}

export default Support
